import React, { useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
// import "react-tooltip/dist/react-tooltip.css";
import ReactTooltip from "react-tooltip";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Label, InputGroup, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import CustomReactSelect from "../../../../components/CustomReactSelect";

const GerneralReimbursementForm = (props) => {
	const mealDatePickerRef = useRef(null);
	const travelDatepickerRef = useRef(null);
	const cashDatepickerRef = useRef(null);

	const openMealDatepicker = () => {
		const datepickerElement = mealDatePickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openTravelDatepicker = () => {
		const datepickerElement = travelDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const opencashDatepicker = () => {
		const datepickerElement = cashDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<Form className="general-reimbursementTable">
			<Label className="general-reimbursement-form-label ">
				<div> General reimbursement form</div>
				{props.recordID && (
					<div className="mr-4">Ticket# {props.recordID}</div>
				)}
			</Label>
			<Form.Group className="meal-type">
				<Row className="align-items-center">
					<Col lg={2}>
						<Form.Label>Meals</Form.Label>
					</Col>
					<Col>
						<InputGroup className="datepicker-wrapper">
							<DatePicker
								showYearDropdown
								showMonthDropdown
								dateFormatCalendar=" " //for title
								name="mealDate"
								className="custom-container"
								onChange={props.mealDatehandleChange}
								selected={props.mealDate}
								value={
									props.generalReimbursement.mealDate
										? moment(
												props.generalReimbursement
													.mealDate
										  ).format("DD/MM/YYYY")
										: ""
								}
								autoComplete="off"
								clearIcon={false}
								calendarIcon={false}
								isOpen={props.mealDateCalendar}
								maxDate={new Date()}
								readOnly={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
								ref={mealDatePickerRef}
							/>
							<FontAwesomeIcon
								icon={faCalendarAlt}
								className="calender-icon"
								color="keppel"
								onClick={() => openMealDatepicker()}
							/>
						</InputGroup>
					</Col>
					<Col>
						<CustomReactSelect
							name="mealType"
							type="text"
							options={props.mealTypes}
							placeholder="Meal type"
							className="general-reimburse-input"
							onChange={props.mealTypeReactSelect}
							value={props.generalReimbursement.mealType}
							isDisabled={
								props.empDepartment === "5" ||
								props.formStatus === "Draft"
									? false
									: true
							}
						/>
					</Col>
					<Col>
						<div class="did-floating-label-content">
							<input
								class="did-floating-input"
								type="number"
								name="mealAmount"
								onChange={props.handleChange}
								value={props.generalReimbursement.mealAmount}
								disabled={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
								onInput={(e) => {
									e.target.value = Math.max(
										0,
										parseInt(e.target.value)
									)
										.toString()
										.slice(0, 6);
								}}
							/>
							<label
								class="did-floating-label"
								style={
									props.generalReimbursement.mealAmount
										? { top: "-8px" }
										: null
								}
							>
								Meal Amount
							</label>
						</div>
					</Col>

					<Col>
						<div
							id="tooltip-top"
							class="did-floating-label-content"
						>
							<input
								data-tip="tooltip<br />multiline"
								data-for="mealDetails"
								class="did-floating-input"
								name="mealDetails"
								type="text"
								maxLength="1000"
								onChange={props.handleChange}
								value={props.generalReimbursement.mealDetails}
								onInput={(e) => {
									e.target.value = e.target.value;
								}}
								readOnly={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
							/>
							<label
								class="did-floating-label"
								style={
									props.generalReimbursement.mealDetails
										? { top: "-8px" }
										: null
								}
							>
								Meal Details
							</label>

							{props.generalReimbursement?.mealDetails?.length !=
								0 &&
								props.generalReimbursement?.mealDetails !=
									null && (
									<ReactTooltip
										id="mealDetails"
										className="ReimbursementToolTip"
										place="bottom"
										effect="solid"
										variant="light"
										positionStrategy="fixed"
									>
										{props.generalReimbursement.mealDetails}
									</ReactTooltip>
								)}
						</div>
					</Col>
				</Row>
			</Form.Group>
			<Form.Group className=" travel">
				<Row className="align-items-center">
					<Col lg={2}>
						<Form.Label>Travel</Form.Label>
					</Col>
					<Col>
						<InputGroup className="datepicker-wrapper">
							<DatePicker
								showYearDropdown
								showMonthDropdown
								dateFormatCalendar=" " //for title
								name="travelDate"
								className="custom-container"
								onChange={props.travelDatehandleChange}
								selected={props.travelDate}
								autoComplete="off"
								clearIcon={false}
								calendarIcon={false}
								isOpen={props.travelDateCalendar}
								maxDate={new Date()}
								value={
									props.generalReimbursement.travelDate
										? moment(
												props.generalReimbursement
													.travelDate
										  ).format("DD/MM/YYYY")
										: " "
								}
								readOnly={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
								ref={travelDatepickerRef}
							/>
							<FontAwesomeIcon
								icon={faCalendarAlt}
								className="calender-icon"
								color="keppel"
								onClick={() => openTravelDatepicker()}
							/>
						</InputGroup>
					</Col>
					<Col>
						<CustomReactSelect
							name="travelType"
							type="text"
							options={props.travelTypes}
							placeholder="Travel type"
							className="general-reimburse-input"
							onChange={props.travelTypeReactSelect}
							value={props.generalReimbursement.travelType}
							isDisabled={
								props.empDepartment === "5" ||
								props.formStatus === "Draft"
									? false
									: true
							}
						/>
					</Col>
					<Col>
						<div class="did-floating-label-content">
							<input
								class="did-floating-input"
								type="number"
								name="travelAmount"
								onChange={props.handleChange}
								value={props.generalReimbursement.travelAmount}
								disabled={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
								onInput={(e) => {
									e.target.value = Math.max(
										0,
										parseInt(e.target.value)
									)
										.toString()
										.slice(0, 6);
								}}
							/>
							<label
								class="did-floating-label"
								style={
									props.generalReimbursement.travelAmount
										? { top: "-8px" }
										: null
								}
							>
								Travel Amount
							</label>
						</div>
					</Col>

					<Col>
						<div class="did-floating-label-content">
							<input
								data-tip="tooltip<br />multiline"
								data-for="travelDetails"
								class="did-floating-input"
								name="travelDetails"
								type="text"
								maxLength="1000"
								onChange={props.handleChange}
								value={props.generalReimbursement.travelDetails}
								onInput={(e) => {
									e.target.value = e.target.value;
								}}
								readOnly={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
							/>
							<label
								class="did-floating-label"
								style={
									props.generalReimbursement.travelDetails
										? { top: "-8px" }
										: null
								}
							>
								Travel Details
							</label>
							{props.generalReimbursement?.travelDetails
								?.length != 0 &&
								props.generalReimbursement?.travelDetails !=
									null && (
									<ReactTooltip
										id="travelDetails"
										className="ReimbursementToolTip"
										place="bottom"
										effect="solid"
										variant="light"
										positionStrategy="fixed"
									>
										{
											props.generalReimbursement
												.travelDetails
										}
									</ReactTooltip>
								)}
						</div>
					</Col>
				</Row>
			</Form.Group>
			<Form.Group className="cash">
				<Row className="align-items-center">
					<Col lg={2}>
						<Form.Label>Cash</Form.Label>
					</Col>
					<Col>
						<InputGroup className="datepicker-wrapper">
							<DatePicker
								showYearDropdown
								showMonthDropdown
								dateFormatCalendar=" " //for title
								name="cashDate"
								className="custom-container"
								onChange={props.cashDatehandleChange}
								selected={props.cashDate}
								autoComplete="off"
								clearIcon={false}
								calendarIcon={false}
								isOpen={props.cashDateCalendar}
								maxDate={new Date()}
								value={
									props.generalReimbursement.cashDate
										? moment(
												props.generalReimbursement
													.cashDate
										  ).format("DD/MM/YYYY")
										: " "
								}
								readOnly={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
								ref={cashDatepickerRef}
							/>
							<FontAwesomeIcon
								icon={faCalendarAlt}
								className="calender-icon"
								color="keppel"
								onClick={() => opencashDatepicker()}
							/>
						</InputGroup>
					</Col>
					<Col>
						<div class="did-floating-label-content">
							<input
								class="did-floating-input"
								type="number"
								name="cashAmount"
								onChange={props.handleChange}
								value={props.generalReimbursement.cashAmount}
								disabled={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
								onInput={(e) => {
									e.target.value = Math.max(
										0,
										parseInt(e.target.value)
									)
										.toString()
										.slice(0, 6);
								}}
							/>
							<label
								class="did-floating-label"
								style={
									props.generalReimbursement.cashAmount
										? { top: "-8px" }
										: null
								}
							>
								Cash Amount
							</label>
						</div>
					</Col>

					<Col>
						<div class="did-floating-label-content">
							<input
								data-tip="tooltip<br />multiline"
								data-for="cashDetails"
								class="did-floating-input"
								name="cashDetails"
								type="text"
								maxLength="1000"
								onChange={props.handleChange}
								value={props.generalReimbursement.cashDetails}
								// disabled={
								// 	props.empDepartment === "5" ||
								// 	props.formStatus === "Draft"
								// 		? false
								// 		: true
								// }
								onInput={(e) => {
									e.target.value = e.target.value;
								}}
								readOnly={
									props.empDepartment === "5" ||
									props.formStatus === "Draft"
										? false
										: true
								}
							/>
							<label
								class="did-floating-label"
								style={
									props.generalReimbursement.cashDetails
										? { top: "-8px" }
										: null
								}
							>
								Cash Details
							</label>
							{props.generalReimbursement?.cashDetails?.length !=
								0 &&
								props.generalReimbursement?.cashDetails !=
									null && (
									<ReactTooltip
										id="cashDetails"
										className="ReimbursementToolTip"
										place="bottom"
										effect="solid"
										variant="light"
										positionStrategy="fixed"
									>
										{props.generalReimbursement.cashDetails}
									</ReactTooltip>
								)}
						</div>
					</Col>
				</Row>
			</Form.Group>
			<Form.Group className="remarks">
				<Row className="align-items-center">
					<Col lg={2}>
						<Form.Label>Remarks</Form.Label>
					</Col>
					<Col>
						<Form.Control
							name="remarks"
							as="textarea"
							rows={3}
							value={props.generalReimbursement.remarks}
							className="general-reimburse-input"
							onChange={props.handleChange}
							maxLength="1000"
							readOnly={
								props.empDepartment === "5" ||
								props.formStatus === "Draft"
									? false
									: true
							}
						/>
					</Col>
				</Row>
			</Form.Group>
			<Row className="d-flex align-items-center">
				<Col lg={12} className="mt-4">
					<div className="remaining-limit">
						<span style={{ fontWeight: "normal" }}>
							Current Month Bill:{" "}
						</span>
						<span className="reimbRemainingLimit">
							{props?.generalReimbursement?.grandTotal?.toLocaleString()}
						</span>
					</div>
				</Col>
				<Col>
					{!props.specificRecord ? (
						<div className="btns">
							<Button
								className="submit-btn leftBtn"
								onClick={props.handleSubmit}
							>
								Submit
							</Button>
							<Button
								className="reset-btn"
								onClick={props.handleReset}
							>
								Reset
							</Button>
						</div>
					) : props.empDepartment === "5" ? (
						<div className="btns">
							<Button
								className="approved-btn"
								onClick={() =>
									props.changeGeneralReimbursementStatus(5)
								}
							>
								Set as Processing
							</Button>
							<Button
								className="approved-btn"
								onClick={() =>
									props.changeGeneralReimbursementStatus(2)
								}
							>
								Set as Approved
							</Button>
							<Button
								className="reject-btn"
								onClick={() =>
									props.changeGeneralReimbursementStatus(3)
								}
							>
								Set as Rejected
							</Button>
							<Button
								className="paid-btn"
								onClick={() =>
									props.changeGeneralReimbursementStatus(4)
								}
							>
								Set as Paid
							</Button>
							<Button
								className="gReimbursementPending-btn"
								onClick={() =>
									props.changeGeneralReimbursementStatus(1)
								}
							>
								Set as Pending
							</Button>
						</div>
					) : null}
				</Col>
			</Row>
		</Form>
	);
};

export default GerneralReimbursementForm;
